import styled from 'styled-components'
import { TYPOGRAPHY, FONT_WEIGHT } from '../../../../../styles/theme'

// ============================================================================
// CARD FOOTER BAR
// A slim bar at the bottom of the node card containing action buttons
// (e.g. Prototype dropdown) and the Sources accordion toggle.
// ============================================================================

const FOOTER_CONFIG = {
  padding: '6px 12px 8px',
  fontSize: TYPOGRAPHY.caption.fontSize,
  fontWeight: FONT_WEIGHT.semibold,
  letterSpacing: '0.5px',
  iconSize: 10,
  sourceCardRadius: '6px',
  sourceCardPadding: '8px 10px',
} as const

export const FooterBarContainer = styled.div`
  border-top: 1px solid var(--color-node-header-border);
  padding: ${FOOTER_CONFIG.padding};
`

export const FooterButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`

export const FooterButton = styled.button`
  display: flex;
  align-items: center;
  gap: 4px;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  padding: 4px 6px;
  margin: -2px -6px;
  font-size: ${FOOTER_CONFIG.fontSize};
  font-weight: ${FOOTER_CONFIG.fontWeight};
  text-transform: uppercase;
  letter-spacing: ${FOOTER_CONFIG.letterSpacing};
  color: var(--color-text-muted);
  transition:
    color 0.15s,
    background-color 0.15s;
  font-family: inherit;

  &:hover {
    color: var(--color-text-secondary);
    background-color: rgba(0, 0, 0, 0.06);
  }
`

export const SourceList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 6px;
`

export const SourceCard = styled.div`
  background: rgba(59, 130, 246, 0.05);
  border: 1px solid rgba(59, 130, 246, 0.15);
  border-radius: ${FOOTER_CONFIG.sourceCardRadius};
  padding: ${FOOTER_CONFIG.sourceCardPadding};
`

export const SourceHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 4px;
`

export const SourceFileName = styled.span`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  color: #3b82f6;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const SourceExcerpt = styled.p`
  font-size: ${TYPOGRAPHY.caption.fontSize};
  line-height: 1.45;
  color: var(--color-text-tertiary);
  margin: 0;
  font-style: italic;
  word-wrap: break-word;
  white-space: pre-wrap;
`
